export default class NumberService {
  tryParseInt = (number: unknown, def?: number) => {
    if (typeof number === 'number') return Math.trunc(number);
    if (number == null || number === undefined) return def;

    const n = parseInt(`${number}`);
    if (isNaN(n)) return def;
    return n;
  }
}